import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingOverlay } from './LoadingOverlay';

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { checkAuth, user, loading } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      await checkAuth(); // ✅ Always run checkAuth to populate user
      setAuthChecked(true);
    };

    initAuth();
  }, [checkAuth]);

  useEffect(() => {
    // Only run redirects after auth has been checked
    if (!authChecked || loading) return;

    // Redirect non-admins away from admin routes
    if (user && location.pathname.includes('/admin') && user.role !== 'administrator') {
      navigate('/');
      return;
    }

    // If user is not logged in, redirect to login with the current path
    if (!user) {
      const redirectTo = location.pathname + location.search;
      navigate('/login', { 
        state: { from: redirectTo },
        replace: true 
      });
      return;
    }
  }, [authChecked, loading, location.pathname, location.search, user, navigate]);

  // Show loading state while checking auth
  if (!authChecked || loading) {
    return <LoadingOverlay message="Opening Luna..." height="100vh" size="lg" />;
  }

  // If we get here, user is authenticated
  return <>{children}</>;
};
